"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStepperStep = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _statusIconAppearance = require("../../util/statusIconAppearance");
var _ProgressStepperStepDot = require("../ProgressStepperStepDot/ProgressStepperStepDot");
var _ProgressStepperStepLabel = require("../ProgressStepperStepLabel/ProgressStepperStepLabel");
var _VisuallyHidden = require("../VisuallyHidden/VisuallyHidden");
var _ProgressStepperStep = require("./ProgressStepperStep.styles");
var _excluded = ["appearance", "active", "alignLabel", "interactive", "icon", "label", "meta", "step", "renderLabel"];
/**
 * A ProgressStepperStep component is used by `ProgressStepper` to identify a certain step.
 *
 * @since 8.42.0
 */
var ProgressStepperStep = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var appearance = props.appearance,
    active = props.active,
    alignLabel = props.alignLabel,
    interactive = props.interactive,
    icon = props.icon,
    label = props.label,
    meta = props.meta,
    step = props.step,
    renderLabel = props.renderLabel,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var iconContent;
  if (appearance && !active) {
    if (typeof icon === 'function') {
      iconContent = icon({
        appearance: appearance
      });
    } else {
      iconContent = icon;
    }
  }

  // Since we represent appearance using icons, include a description
  // for screen readers.
  var iconAltText = '';
  if (typeof appearance !== 'undefined' && appearance !== 'none') {
    iconAltText = /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, null, appearance);
  }
  return /*#__PURE__*/_react.default.createElement(_ProgressStepperStep.StyledProgressStepperStep, (0, _extends2.default)({
    ref: forwardedRef,
    as: interactive ? undefined : 'div',
    alignLabel: alignLabel,
    appearance: appearance,
    active: active,
    "aria-current": active ? 'step' : undefined,
    interactive: interactive
    // Only `null` works to override UnstyledButton's defaultProps for `type`
    ,
    type: interactive ? 'button' : null
  }, rest), /*#__PURE__*/_react.default.createElement(_ProgressStepperStepDot.ProgressStepperStepDot, null, iconAltText, iconContent), renderLabel(props));
});
exports.ProgressStepperStep = ProgressStepperStep;
ProgressStepperStep.displayName = 'ProgressStepperStep';
ProgressStepperStep.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Indicates this is the current, active step.
   */
  active: _propTypes.default.bool,
  /**
   * Sets the horizontal alignment for the label.
   *
   * All labels in a `ProgressStepper` must have the same alignment. Therefore,
   * alignment is determined by the parent `ProgressStepper` and cannot be
   * overridden for an individual step.
   *
   * @since 8.57.0
   * @ignore
   */
  alignLabel: _propTypes.default.oneOf(Object.values(_constants.PROGRESS_STEPPER_LABEL_ALIGNMENTS)),
  /**
   * Changes the appearance of a step to show its status. If no appearance is
   * provided, the step will appear in the default, "not started" state.
   */
  appearance: _propTypes.default.oneOf(Object.values(_constants.PROGRESS_STEPPER_APPEARANCES)),
  /**
   * The icon node. By default, this will use an icon based on the `appearance`.
   */
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * If true, user will be able to click on and navigate to the step.
   */
  interactive: _propTypes.default.bool,
  /**
   * Label text of the step.
   */
  label: _propTypes.default.string.isRequired,
  /**
   * Additional content that will appear underneath the step label text. Currently,
   * `Tag` and text are officially supported. For more
   * customization options, you can use the `renderLabel` prop.
   *
   * It's best to avoid long `meta` values to help maintain understandability
   * for screen reader users.
   *
   * @since 8.57.0
   */
  meta: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /**
   * Changes the step style to work with either the horizontal or vertical version
   * of the `ProgressStepper`.
   *
   * @since 8.57.0
   * @ignore
   */
  orientation: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(Object.values(_constants.ORIENTATIONS))),
  /**
   * A function that takes a props object as an argument and returns a step label
   * component, by default a `ProgressStepperStepLabel`.
   */
  renderLabel: _propTypes.default.func
} : {};
ProgressStepperStep.defaultProps = {
  alignLabel: _constants.PROGRESS_STEPPER_LABEL_ALIGNMENTS.CENTER,
  icon: _statusIconAppearance.statusIconAppearance,
  orientation: _constants.ORIENTATIONS.horizontal,
  renderLabel: function renderLabel(props) {
    return /*#__PURE__*/_react.default.createElement(_ProgressStepperStepLabel.ProgressStepperStepLabel, props);
  }
};